import React from 'react';

import { PROVIDER_UNAVAILABLE_MESSAGE, PROVIDER_UNAVAILABLE_TITLE } from 'shared/content/constants';
import SingleActionDialog from './SingleActionDialog';

interface ProviderUnavailableDialogProps {
  open: boolean;
  // Called for both the OK button and closing the dialog - either way the patient can't book
  // online, so the caller sends them back to the dashboard.
  onOk: () => void;
}

/**
 * Tells an existing patient that online booking isn't available because their primary provider
 * is no longer available (see PatientSelfSchedulingContext.primaryProviderUnavailable), and asks
 * them to call to schedule. Uses SingleActionDialog's responsive, centred single-OK layout.
 */
const ProviderUnavailableDialog = ({ open, onOk }: ProviderUnavailableDialogProps) => (
  <SingleActionDialog
    open={open}
    title={PROVIDER_UNAVAILABLE_TITLE}
    message={PROVIDER_UNAVAILABLE_MESSAGE}
    onOk={onOk}
  />
);

export default ProviderUnavailableDialog;
